import { userService } from "../services";
 
import { userConstants,dealerConstants, roleMasterConstants } from "../constants";
import { alertActions } from ".";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
 
export const userMasterActions = {
  getAll,
  getRoleDDL,
  getDistrictDDL,
  getCityDDL,
  getStateDDL,
  createUser,
  updateUser,
  inActiveRow,
  onHideShow,
  loadingData,
  onHideShowIsActive,
  rejectUser,
  approveUser,
  getAllForApproval,
  exportData,
  getWDDL,
  getSDDL,
  getRDDL,
  getASMDDL,
  getGDDL,
  createUserDetails
};
 
function getDistrictDDL(stateId) {
  ;
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchDistDLL(stateId).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: roleMasterConstants.GETDISTRICTDDL_REQUEST };
  }
  function success(datas) {
    return { type: roleMasterConstants.GETDISTRICTDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: roleMasterConstants.GETDISTRICTDDL_FAILURE, error };
  }
}
 
function getCityDDL(districtId) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchCityDLL(districtId).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: roleMasterConstants.GETCITYDDL_REQUEST };
  }
  function success(datas) {
    return { type: roleMasterConstants.GETCITYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: roleMasterConstants.GETCITYDDL_FAILURE, error };
  }
}
 
function getStateDDL(countryId) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchStateDDL(countryId).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETSTATEDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETSTATEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETSTATEDDL_FAILURE, error };
  }
}


function getAll(obj) {
  return (dispatch) => {
    dispatch(request());
    userService.fetchUserData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}
function getAllForApproval(obj) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchUserApprovalData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}
function approveUser(user) {
  var data = {
    UserId: user,
  };
  return (dispatch) => {
    dispatch(request());
 
    userService.approveUser(user).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: userConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.ISACTIVE_FAILURE, error };
  }
}
 
function rejectUser(user) {
  var data = {
    UserId: user,
  };
  return (dispatch) => {
    dispatch(request());
 
    userService.rejectUser(user).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: userConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.ISACTIVE_FAILURE, error };
  }
}
 
function getRoleDDL(data) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchRoleDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETROLEDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETROLEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETROLEDDL_FAILURE, error };
  }
}
 
 
 
 
 
function getWDDL(data) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchWDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETWDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETWDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETWDDL_FAILURE, error };
  }
}
 
function getSDDL(data) {
  debugger;
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchSDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETSDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETSDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETSDDL_FAILURE, error };
  }
}
 
function getRDDL(data) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchRDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETRDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETRDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETRDDL_FAILURE, error };
  }
}
 
function getASMDDL(data) {
 
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchASMDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETASMDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETASMDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETASMDDL_FAILURE, error };
  }
}
 
function getGDDL(data) {
  return (dispatch) => {
    dispatch(request());
 
    userService.fetchGDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.GETGDDL_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETGDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETGDDL_FAILURE, error };
  }
}
 
 
function createUser(data) {
  return (dispatch) => {
    dispatch(request(data));

    // Return the promise so that .then() can be chained in the component
    return userService.createUser(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            toast.success(response.ResponseMessage);
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
        return response;
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error; // To allow .catch() in component
      }
    );
  };

  function request(data) {
    return { type: userConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.CREATE_FAILURE, error };
  }
}


 
function createUserDetails(data) {
  return (dispatch) => {
    dispatch(request(data));

    return userService.createUserDetails(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
        return response;
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error;
      }
    );
  };

  function request(data) {
    return { type: dealerConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: dealerConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealerConstants.CREATE_FAILURE, error };
  }
}

function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    userService.fetchUserDataExport(obj).then(
      (response) => {
        ;
        dispatch(loadingData(false));
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.TotalRows;
            delete v.UserId;
            delete v.FirstName;
            delete v.LastName;
            delete v.RoleId;
            delete v.UserType;
            delete v.IsActive;
            delete v.IsResetPassword;
            delete v.Password;
            delete v.Token;
            delete v.RefreshToken;
            delete v.Salt;
            delete v.CreatedBy;
            delete v.UpdatedBy;
            delete v.isDeleted;
            delete v.isApproved;
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: userConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: userConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: userConstants.GETEXPORT_FAILURE, error };
  }
}
 
function updateUser(data) {
  return (dispatch) => {
    dispatch(request(data));

    // 🔧 Return the Promise so that .then() works in the component
    return userService.updateUser(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
        return response; // ✅ allow chaining
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error; // ✅ make .catch() work
      }
    );
  };

  function request(data) {
    return { type: userConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_FAILURE, error };
  }
}

 
function inActiveRow(user, isActive) {
  var data = {
    UserId: user,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());
 
    userService.inActiveRow(user, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
 
  function request() {
    return { type: userConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: userConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.ISACTIVE_FAILURE, error };
  }
}
 
function onHideShow(isbool) {
  return {
    type: userConstants.DIALOG_REQUEST,
    isbool,
  };
}
 
function loadingData(isbool) {
  return {
    type: userConstants.LOADING_REQUEST,
    isbool,
  };
}
 
function onHideShowIsActive(isbool) {
  return {
    type: userConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}